import React, { Fragment } from "react";
import "./App.css";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Intro from "./components/pages/Intro/Intro";
import Home from "./components/pages/Home/Home";

function App() {
  return (
    <Fragment>
      <BrowserRouter>
        <Routes>
          <Route path="/" Component={Intro} />
          <Route path="/home" Component={Home} />
        </Routes>
      </BrowserRouter>
      {/* <ReactDOM.createPortal></ReactDOM.createPortal> */}
    </Fragment>
  );
}

export default App;
